import React from 'react';
import { getMaxElementForBatchUpdateLimit } from 'utils/statement-content-page-utils';
import { ReactComponent as Warning } from 'icons/warning.svg';
import { toast } from 'react-toastify';
import Notification from 'components/common/notification-component';

export const batchMaxAmountNotification = (key = null) => {
  toast.warning(
    <Notification
      icon={<Warning />}
      title={{ id: 'common.batch-warning-title' }}
      message={{
        id: 'common.batch-warning-message',
        values: { limit: getMaxElementForBatchUpdateLimit(key) },
      }}
    />,
    { autoClose: 3000 },
  );
};
